// components/RevenueTable.tsx
import React, { useMemo } from 'react';
import { useGetReportExistingVsProjectionVsNewOutlet } from '../core/_query';
import { useQueryRequest } from '../core/QueryRequestProvider';
import { FormattedNumber, IntlProvider } from 'react-intl';
import moment from 'moment';
import DashboardPnLvsTargetTargetCard from './DashboardPnLvsTargetCard';

const DashboardExistingVsProjectionVsNewOutletCard: React.FC = () => {

  const { state } = useQueryRequest()
  const { data: cardData } = useGetReportExistingVsProjectionVsNewOutlet(state)

  const data = useMemo(() => {
    return cardData?.response?.data
  }, [cardData])

  const currentMonth = moment().format('MMMM')
  const currentYear = moment().format('yyyy')

  return (
    <div className={`card`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Outlet Existing vs Outlet Projection vs New Outlet</span>
        </h3>
      </div>
      <div className='card-body'>
        <table className="table table-bordered table-sm table-striped">
          <thead className="table-light text-center align-middle">
            <tr>
              <th rowSpan={2}>YEAR</th>
              <th colSpan={2}>EXISTING</th>
              <th colSpan={2}>NEW OUTLET (TARGET/PROYEKSI)</th>
              <th colSpan={2}>ACTUAL NEW OUTLET</th>
              <th rowSpan={2}>
                TARGET/BUDGETING<br />(EXISTING + NEW OUTLET)
              </th>
              <th rowSpan={2}>
                TOTAL ACTUAL<br />NEW OUTLET + EXISTING
              </th>
              <th rowSpan={2}>(+/-) %</th>
            </tr>
            <tr>
              <th>QTY</th>
              <th>REVENUE (ALL)</th>
              <th>QTY (PROYEKSI)</th>
              <th>REVENUE ALL (PROYEKSI)</th>
              <th>QTY (STORED)</th>
              <th>REVENUE ALL (STORED)</th>
            </tr>
          </thead>
          <tbody className="text-center align-middle">
            {
              data?.map((e, i) => {
                return <tr>
                  <td>{Number(currentYear) === e?.years ? `${currentMonth} ${e.years} (YTD)` : e.years}</td>
                  <td>{e?.total_outlet_existing ?? 0}</td>
                  <td>
                    <IntlProvider locale='id'>
                      <FormattedNumber
                        value={
                          e?.revenue_outlet_existing || 0
                        }
                      />
                    </IntlProvider>
                  </td>
                  <td>{e?.total_outlet_projection ?? 0}</td>
                  <td>
                    <IntlProvider locale='id'>
                      <FormattedNumber
                        value={
                          e?.revenue_target_projection || 0
                        }
                      />
                    </IntlProvider>
                  </td>
                  <td>{e?.total_outlet_new}</td>
                  <td>
                    <IntlProvider locale='id'>
                      <FormattedNumber
                        value={
                          e?.revenue_outlet_new || 0
                        }
                      />
                    </IntlProvider>
                  </td>
                  <td>
                    <IntlProvider locale='id'>
                      <FormattedNumber
                        value={
                          e?.revenue_budgeting_target || 0
                        }
                      />
                    </IntlProvider>
                  </td>
                  <td>
                    <IntlProvider locale='id'>
                      <FormattedNumber
                        value={
                          (e?.total_outlet_existing || 0) + (e?.total_outlet_new || 0)
                        }
                      />
                    </IntlProvider>
                  </td>
                  <td>{e?.percentage ?? '0%'}</td>
                </tr>
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DashboardExistingVsProjectionVsNewOutletCard;
